'use strict';

var React = require('react');
//Components
var PersonalInfo = require('./PersonalInfo.jsx');
var ContactDetails = require('./ContactDetails.jsx');
var Tfn = require('../Common/Tfn.jsx');
var Occupation = require('./Occupation.jsx');
var Address = require('./Address.jsx');
var Residence = require('./Residence.jsx');
var YourDetailsConstants = require('../../constants/YourDetailsConstants');

var IndividualAnnuityTrustee = React.createClass({
    propTypes: {
        content: React.PropTypes.object,
        formKey: React.PropTypes.string
    },
    render: function () {
        return (
                <div key={this.props.index}>
                    <PersonalInfo index={this.props.index}
                                  data={this.props.data}
                                  titleList={this.props.titleList}
                                  section="ydTrustee"
                                  isFullNameMessageHidden={true}
                                  errorList={this.props.errorList} />
                    <Occupation index={this.props.index}
                                data={this.props.data}
                                section="ydTrustee"
                                formKey={this.props.formKey}
                                errorList={this.props.errorList} />
                    <Address index={this.props.index}
                             data={this.props.data.addressInfo}
                             section="ydTrustee"
                             withPostalAddress={false}
                             errorList={this.props.errorList} />
                    <Residence index={this.props.index}
                               data={this.props.data}
                               type={YourDetailsConstants.ResidenceType.COUNTRY_RESIDENCE}
                               countryLabel="Your main country of residence?"
                               section="ydTrustee"
                               errorList={this.props.errorList}
                               showQuestion={false} />
                    <Tfn index={this.props.index}
                         productId={this.props.productId}
                         accountType={this.props.accountType}
                         formKey={this.props.formKey}
                         tfnNumber={this.props.data.tfnNumber}
                         tfnNumberReadonly={this.props.data.tfnNumberReadonly}
                         tfnExemptionReason={this.props.data.tfnExemptionReason}
                         tfnExemptionReasonReadonly={this.props.data.tfnExemptionReasonReadonly}
                         tfnExemptionList={this.props.tfnExemptionList}
                         hasTfnExemptionRightText="If applicable"
                         hasTfnExemption={this.props.data.hasTfnExemption}
                         hasTfnExemptionReadonly={this.props.data.hasTfnExemptionReadonly}
                         tfnConsentFlag={this.props.data.tfnConsentFlag}
                         tfnWithConsent={this.props.data.tfnWithConsent}
                         section="ydTrustee"
                         errorList={this.props.errorList} />
                    <Residence index={this.props.index}
                               data={this.props.data}
                               type={YourDetailsConstants.ResidenceType.TAX_RESIDENCE}
                               countryLabel="Select country of tax residence"
                               section="ydTrustee"
                               errorList={this.props.errorList
                    } />
                    <Residence index={this.props.index}
                               data={this.props.data}
                               type={YourDetailsConstants.ResidenceType.CITIZENSHIP}
                               section="ydTrustee"
                               errorList={this.props.errorList} />
                    <ContactDetails index={this.props.index}
                                    data={this.props.data}
                                    productId={this.props.productId}
                                    accountType={this.props.accountType}
                                    formKey={this.props.formKey}
                                    content={this.props.content}
                                    section="ydTrustee"
                                    errorList={this.props.errorList} />
                </div>
        );
    }
});

module.exports = IndividualAnnuityTrustee;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/IndividualAnnuityTrustee.jsx